import counter from './counter'
const countAnimationGroup = {}
countAnimationGroup.count = function(countGroup){
  Array.prototype.forEach.call(countGroup, group => {
    const syncStart = group.getAttribute('data-sync-start')
		const counts = group.querySelectorAll('.count')
		Array.prototype.forEach.call(counts, (c, index) => {
			const countWrap = c.parentNode
			const counterClass = new counter()
			if (c.className.search('counting') == -1) {
				c.classList.add('counting')
				countWrap.classList.add('trans')
				counterClass.start(c, `introCount_${index}`, 20)
			}
		})
	})
}
countAnimationGroup.reset = function(countGroup){
	Array.prototype.forEach.call(countGroup, group => {
    const syncStart = group.getAttribute('data-sync-start')
		const counts = group.querySelectorAll('.count')
		Array.prototype.forEach.call(counts, (c, index) => {
			const countWrap = c.parentNode
			const counterClass = new counter()
			if (c.className.search('counting') !== -1) {
				c.classList.remove('counting')
				countWrap.classList.remove('trans')
				counterClass.reset(c, `introCount_${index}`)
			}
		})
	})
}

export default countAnimationGroup